import React from 'react'
import ThirdPartyToolsContainer from '../../modules/GAThirdPartyTools/containers/ThirdPartyToolsContainer/ThirdPartyToolsContainer';
const GAThirdPartyTools = () => {
  return <ThirdPartyToolsContainer />
}

export default GAThirdPartyTools;